export default __webpack_public_path__ + "static/media/ep4collage6.474b4512.jpg";